module.exports = __webpack_public_path__ + "img/paperplane.32ed26f2.svg";